'use client';
import { logo_white } from '@/images';
import { setLocationPopup } from '@/redux/actions/common.action';
import { AppDispatch, RootState } from '@/redux/store';
import { ChevronDown, MapPin } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LocationDialog, ProfileChip, SearchBar } from './components';
import { usePathname, useParams } from 'next/navigation';

export default function Navbar(): React.ReactNode {
  const dispatch = useDispatch<AppDispatch>();
  const location = useSelector((state: RootState) => state.location);
  const pathname = usePathname();  
  const params = useParams();
  const pageName = pathname.split('/')[2];
  const firstPathSegment = pathname.split('/')[1];
  const showLocation = !(
    pageName === 'buy-page' || 
    pageName === 'checkout' || 
    !!params?.eventId ||
    ['user', 'grow-waterpark-bookings', 'upgrade-ticketing-system', 'launch-adventurepark-ticketing', 'landing'].includes(firstPathSegment)
  );

  const handleOpenLocationDialog = () => {
    dispatch(setLocationPopup(true));
  };

  return (
    <>
      <nav
        aria-label='Global Navigation'
        className='flex h-14 items-center bg-black'
      >
        <section className='mx-auto flex w-full max-w-7xl items-center justify-between px-3 sm:px-6'>
          <div className='flex items-center gap-2'>
            <Link href='/' className='flex items-center gap-2'>
              <Image
                alt='Greet Fydo Logo'
                aria-label='Greet Fydo Logo'
                className='mb-1 h-6 w-auto sm:h-8 shrink-0'
                src={logo_white}
              />
            </Link>
          </div>
          <section className='flex items-center gap-2'>
            {/* <Link
            aria-label='List Your Event'
            className='mr-1 hidden h-9 items-center justify-start gap-2 rounded-lg bg-[#c01515] px-4 py-3 font-semibold text-white sm:flex'
            href='/organizer'
            onClick={() => trackBtnClick('List Your Event', '/organizer')}
          >
            <p className='text-[10px]! font-bold tracking-wider'>
              LIST YOUR EVENT
            </p>
          </Link> */}
            {showLocation && (
              <>
                <button
                  className='hidden sm:flex items-center gap-2 cursor-pointer group/location-button'
                  onClick={handleOpenLocationDialog}
                >
                  <div className='hover:text-primary h-9 w-9 rounded-lg border border-zinc-800 text-white flex justify-center items-center p-2 bg-zinc-910 bg-zinc-900 group-hover/location-button:bg-zinc-800'>
                    <MapPin className='text-primary' />
                  </div>
                  <div className='hidden sm:flex flex-col items-start justify-between'>
                    <p className='text-sm font-semibold text-white'>{location?.city}</p>
                    <p className='text-xs font-semibold text-gray-500'>{location?.state}</p>
                  </div>
                </button>
                <div className='hidden h-14 border-r border-zinc-800 md:block mx-2' />
                <SearchBar />
              </>
            )}
            <ProfileChip />
          </section>
        </section>
        <LocationDialog />
      </nav>

      {showLocation && (
        <button
          onClick={handleOpenLocationDialog}
          className='w-full sm:hidden flex items-center justify-center gap-2 py-2 bg-zinc-900 border-t border-b border-zinc-800 active:bg-zinc-800 transition-colors'
        >
          <div className='flex items-center justify-center gap-2 max-w-[80%]'>
            <MapPin className='text-primary shrink-0' size={14} />
            <p className='text-white text-sm font-semibold truncate'>
              {location?.city}
            </p>
            <ChevronDown className="text-zinc-500 shrink-0" size={14} />
          </div>
        </button>
      )}
    </>
  );
}
